export const CAR_STATUS = Object.freeze({
    STATUS_ONLINE: 1,
    STATUS_OFFLINE: 2,
    STATUS_INACTIVE: 3
})

export const VEHICLE_STATUS_NAME = Object.freeze({
    DRIVING: 'Driving',
    OFFLINE: 'Offline',
    SLEEP: 'Sleep'
})

export const FLEETS_ALLOWED_ROLES = Object.freeze([
    'Technician',
    'Fleet manager'
])

export const EMIT_EVENTS = Object.freeze({
    'SHARE_EVENT_CREATED': 'SHARE_EVENT_CREATED'
})
